import Model from "../Model";

class product extends Model{

    buildUrl ({ param }) {
        return ['retail/products', param];
    }

    all(config = {}) {
        return this.request({ method: 'GET', action: 'all', ...config });
    }
}


export default new product;